import { useState, useEffect } from 'react';
import { hasWindow } from '../../utils';

function getWindowDimensions() {
    if (!hasWindow()) {
        return { width: 0, height: 0 };
    }
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height,
    };
}

export default function useClientWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        if (!hasWindow()) {
            return;
        }
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
}
